(() => {
  const root = document.documentElement;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const releaseDeferredHoverImage = (target) => {
    if (!finePointer.matches || !(target instanceof Element)) return;

    const link = target.closest('.product-item__image-link, .edge-product-grid__media-link');
    const source = link?.querySelector('source[data-sb-deferred-srcset]');
    if (!link || !source) return;

    const image = source.closest('picture')?.querySelector('img');
    const wrapper = image?.closest('.image');
    const markReady = () => {
      wrapper?.classList.add('sb-hover-image-ready');
      link.classList.add('sb-hover-image-ready');
    };

    if (image) {
      image.loading = 'eager';
      image.fetchPriority = 'low';
      image.addEventListener('load', markReady, { once: true });
    }

    source.srcset = source.dataset.sbDeferredSrcset;
    source.removeAttribute('data-sb-deferred-srcset');

    if (image?.complete && image.naturalWidth > 0) markReady();
  };

  document.addEventListener('pointerover', (event) => {
    releaseDeferredHoverImage(event.target);
  }, { passive: true, capture: true });

  document.addEventListener('focusin', (event) => {
    releaseDeferredHoverImage(event.target);
  }, true);

  const resetRestoredProductCardState = () => {
    document.querySelectorAll('.product-item__image--two.active').forEach((image) => {
      image.classList.remove('active');
    });

    const activeElement = document.activeElement;
    if (
      activeElement instanceof HTMLElement
      && activeElement.closest('.product-item')
      && !activeElement.matches(':focus-visible')
    ) {
      activeElement.blur();
    }
  };

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    resetRestoredProductCardState();
    requestAnimationFrame(resetRestoredProductCardState);
  });

  const normalizePathname = pathname => pathname.replace(/\/+$/, '') || '/';

  document.addEventListener('click', event => {
    const drawer = event.target.closest('[data-drawer-menu]');
    const link = event.target.closest('a[href]');
    if (!drawer || !link || !drawer.contains(link)) return;

    const item = link.getAttribute('data-item');
    const href = link.getAttribute('href');
    if ((item && item !== 'link') || !href || href.charAt(0) === '#') return;

    const destination = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);
    if (
      destination.origin !== current.origin
      || normalizePathname(destination.pathname) !== normalizePathname(current.pathname)
    ) return;

    document.querySelector('.header__icon-menu[aria-expanded="true"]')?.click();

    if (history.state?.scummyDrawer) {
      const nextState = { ...history.state };
      delete nextState.scummyDrawer;
      delete nextState.scummyDrawerParent;
      delete nextState.scummyDrawerScroll;
      history.replaceState(nextState, '', window.location.href);
    }
  }, true);

  const showQuickAddTriggers = () => {
    requestAnimationFrame(() => root.classList.add('sb-quick-add-ready'));
  };

  if (document.readyState === 'complete') {
    showQuickAddTriggers();
  } else {
    document.addEventListener('DOMContentLoaded', showQuickAddTriggers, { once: true });
  }
  let startX = 0;
  let startY = 0;
  let touchIsMoving = false;

  const clearMovingState = () => {
    requestAnimationFrame(() => {
      root.classList.remove('sb-touch-moving');
      touchIsMoving = false;
    });
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;
    startX = event.clientX;
    startY = event.clientY;
    touchIsMoving = false;
    root.classList.remove('sb-touch-moving');
  }, { passive: true, capture: true });

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'touch' || touchIsMoving) return;
    if (Math.hypot(event.clientX - startX, event.clientY - startY) < 7) return;
    touchIsMoving = true;
    root.classList.add('sb-touch-moving');
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  }, { passive: true, capture: true });

  document.addEventListener('pointerup', clearMovingState, { passive: true, capture: true });
  document.addEventListener('pointercancel', clearMovingState, { passive: true, capture: true });

  const rebuyAllProductsSelector = '.rebuy-cart__flyout-empty-cart a[href="/collections/all"]';
  const shopAllUrl = '/collections/all-products';
  const quickSearch = document.querySelector('[data-quick-search]');
  const quickSearchPage = quickSearch?.parentElement;
  const quickSearchInertTargets = new Set();

  const normalizeRebuyLink = (link) => {
    link.setAttribute('href', shopAllUrl);
  };

  const setQuickSearchSiblingsInert = (isOpen) => {
    if (!quickSearchPage || !quickSearch) return;

    if (isOpen) {
      [...quickSearchPage.children].forEach((element) => {
        if (element === quickSearch || element.hasAttribute('inert')) return;
        element.setAttribute('inert', '');
        quickSearchInertTargets.add(element);
      });
      return;
    }

    quickSearchInertTargets.forEach((element) => {
      element.removeAttribute('inert');
    });
    quickSearchInertTargets.clear();
  };

  const syncQuickSearchInertState = () => {
    setQuickSearchSiblingsInert(quickSearch?.getAttribute('aria-hidden') === 'false');
  };

  document.addEventListener('click', (event) => {
    if (!quickSearch) return;

    const searchTrigger = event.target.closest('[data-search]');
    if (searchTrigger) {
      setQuickSearchSiblingsInert(quickSearch.getAttribute('aria-hidden') !== 'false');
      return;
    }

    const closeTarget = event.target.closest('[data-close-icon], [data-overlay]');
    if (
      quickSearch.getAttribute('aria-hidden') === 'false'
      && closeTarget
      && quickSearch.contains(closeTarget)
    ) {
      setQuickSearchSiblingsInert(false);
    }
  }, true);

  quickSearch?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setQuickSearchSiblingsInert(false);
  }, true);

  if (quickSearch) {
    new MutationObserver(syncQuickSearchInertState).observe(quickSearch, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  const normalizeRebuyProductName = (link) => {
    const card = link.closest('.rebuy-product-block');
    const title = card?.querySelector('.rebuy-product-title-link')?.textContent.trim()
      || link.querySelector('img[alt]')?.alt.trim();
    if (title) link.setAttribute('aria-label', `View ${title}`);
  };

  const removeDuplicateInstafeedIds = () => {
    ['instafeed-tagged-by-username', 'instafeed-product-reviews-count'].forEach((id) => {
      document.querySelectorAll(`[id="${id}"]`).forEach((element, index) => {
        if (index > 0) element.removeAttribute('id');
      });
    });
  };

  const normalizeProductLightbox = (node) => {
    if (!(node instanceof Element)) return;

    const dialog = node.matches('.pswp--product-lightbox')
      ? node
      : node.querySelector('.pswp--product-lightbox');
    const productTitle = document.querySelector('main h1')?.textContent.trim();
    if (
      dialog
      && productTitle
      && !dialog.hasAttribute('aria-label')
      && !dialog.hasAttribute('aria-labelledby')
    ) {
      dialog.setAttribute('aria-label', productTitle);
    }
  };

  const normalizeRebuyLinksInNode = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(rebuyAllProductsSelector)) normalizeRebuyLink(node);
    node.querySelectorAll(rebuyAllProductsSelector).forEach(normalizeRebuyLink);
    if (node.matches('.rebuy-product-image')) normalizeRebuyProductName(node);
    node.querySelectorAll('.rebuy-product-image').forEach(normalizeRebuyProductName);
  };

  document.querySelectorAll(rebuyAllProductsSelector).forEach(normalizeRebuyLink);
  document.querySelectorAll('.rebuy-product-image').forEach(normalizeRebuyProductName);
  document.querySelectorAll('.pswp--product-lightbox').forEach(normalizeProductLightbox);
  removeDuplicateInstafeedIds();

  const syncProductOptionState = (button) => {
    if (!button.matches('[data-option-buttons] [data-button]')) return;
    button.setAttribute('aria-pressed', button.classList.contains('selected') ? 'true' : 'false');

    const optionLabel = button.dataset.optionAccessibleLabel;
    const unavailableLabel = button.dataset.optionUnavailableLabel;
    if (optionLabel) {
      button.setAttribute(
        'aria-label',
        button.classList.contains('disabled') && unavailableLabel
          ? `${optionLabel}, ${unavailableLabel}`
          : optionLabel
      );
    }
  };

  document.querySelectorAll('[data-option-buttons] [data-button]').forEach(syncProductOptionState);

  // The theme's regular product form emits this DOM event after Shopify
  // returns the updated cart, but the header only listens to its private bus.
  // Keep the visible badge in sync with the confirmed cart response.
  const updateCartCount = (itemCount) => {
    if (!Number.isInteger(itemCount)) return;
    document.querySelectorAll('[data-js-cart-count]').forEach((cartCount) => {
      const nextCount = String(itemCount);
      if (cartCount.textContent !== nextCount) cartCount.textContent = nextCount;
    });
  };

  document.addEventListener('cart:updated', (event) => {
    updateCartCount(event.detail?.cart?.item_count);
  });

  const syncCartCountFromRebuy = () => {
    const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label');
    const itemCountMatch = subtotalLabel?.textContent.match(/\((\d+) items?\)/i);
    if (itemCountMatch) updateCartCount(Number(itemCountMatch[1]));
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(normalizeRebuyLinksInNode);
      mutation.addedNodes.forEach(normalizeProductLightbox);
      if (mutation.type === 'attributes') {
        syncProductOptionState(mutation.target);
        normalizeProductLightbox(mutation.target);
      }
    });
    removeDuplicateInstafeedIds();
    syncCartCountFromRebuy();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
})();

/* Keep desktop quick add attached to the product card that opened it. */
(() => {
  let quickAddCard = null;
  let quickAddProductItem = null;
  let quickAddTrigger = null;

  const quickViewPage = document.querySelector('.page');
  const pageAlreadyIgnoredScrollLock = quickViewPage?.hasAttribute('data-scroll-lock-ignore');
  const quickViewInertTargets = new Set();

  const unlockQuickViewScroll = () => {
    if (window.innerWidth < 720) return;
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    if (quickViewPage) quickViewPage.setAttribute('data-scroll-lock-ignore', '');
  };

  const restoreQuickViewScroll = () => {
    if (quickViewPage && !pageAlreadyIgnoredScrollLock) quickViewPage.removeAttribute('data-scroll-lock-ignore');
  };

  const clearQuickAddSource = () => {
    quickAddProductItem?.classList.remove('sb-quick-add-source');
    quickAddProductItem = null;
  };

  const setQuickViewSiblingsInert = (isInert) => {
    const quickView = document.querySelector('[data-quick-view-modal]');
    if (!quickView?.parentElement) return;

    if (isInert) {
      [...quickView.parentElement.children].forEach((element) => {
        if (element === quickView || element.hasAttribute('inert')) return;
        element.setAttribute('inert', '');
        quickViewInertTargets.add(element);
      });
      return;
    }

    quickViewInertTargets.forEach((element) => element.removeAttribute('inert'));
    quickViewInertTargets.clear();
  };

  const quickViewFocusableElements = (quickView) => (
    [...quickView.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.getClientRects().length > 0)
  );

  const syncQuickViewAccessibility = ({ moveFocus = false } = {}) => {
    const quickView = document.querySelector('[data-quick-view-modal]');
    if (!quickView) return;

    const isActive = quickView.classList.contains('active');
    const isMobileModal = window.innerWidth < 720;
    quickView.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    quickView.setAttribute('aria-modal', isMobileModal ? 'true' : 'false');
    setQuickViewSiblingsInert(isActive && isMobileModal);

    if (!isActive) return;

    const triggerLabel = quickAddTrigger?.getAttribute('aria-label')?.trim();
    if (triggerLabel) quickView.setAttribute('aria-label', triggerLabel);

    if (moveFocus && !quickView.contains(document.activeElement)) {
      requestAnimationFrame(() => {
        const firstOption = quickView.querySelector('[data-option-buttons] [data-button]:not([disabled])');
        const closeButton = quickView.querySelector('[data-modal-close]');
        (firstOption || closeButton)?.focus();
      });
    }
  };

  const placeDesktopQuickAdd = () => {
    const quickView = document.querySelector('[data-quick-view-modal]');
    if (!quickView) return;

    if (window.innerWidth < 720 || !quickAddCard) {
      quickView.style.removeProperty('--sb-qv-card-top');
      quickView.style.removeProperty('--sb-qv-card-left');
      quickView.style.removeProperty('--sb-qv-card-width');
      quickView.removeAttribute('data-sb-qv-positioned');
      return;
    }

    const rect = quickAddCard.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) {
      quickView.removeAttribute('data-sb-qv-positioned');
      return;
    }
    const viewportGutter = 12;
    const minimumPanelWidth = 300;
    const maximumPanelWidth = 360;
    const panelWidth = Math.min(
      Math.max(rect.width, minimumPanelWidth),
      maximumPanelWidth,
      window.innerWidth - (viewportGutter * 2)
    );
    const cardBottom = rect.bottom + window.scrollY;
    const centeredPanelLeft = rect.left + window.scrollX - ((panelWidth - rect.width) / 2);
    const panelLeft = Math.min(
      Math.max(centeredPanelLeft, window.scrollX + viewportGutter),
      window.scrollX + window.innerWidth - panelWidth - viewportGutter
    );

    quickView.style.setProperty('--sb-qv-card-top', `${cardBottom}px`);
    quickView.style.setProperty('--sb-qv-card-left', `${panelLeft}px`);
    quickView.style.setProperty('--sb-qv-card-width', `${panelWidth}px`);
    quickView.setAttribute('data-sb-qv-positioned', 'true');

    requestAnimationFrame(unlockQuickViewScroll);
  };

  const closeDesktopQuickAdd = () => {
    if (window.innerWidth < 720) return;
    const quickView = document.querySelector('[data-quick-view-modal].active');
    const closeButton = quickView?.querySelector('[data-modal-close]');
    if (closeButton) closeButton.click();
  };

  const setQuickAddAnchor = event => {
    const trigger = event.target.closest('.sb-quick-add-trigger');
    if (!trigger) return;
    quickAddTrigger = trigger;
    const productItem = trigger.closest('.product-item');
    if (quickAddProductItem !== productItem) {
      clearQuickAddSource();
      quickAddProductItem = productItem;
      quickAddProductItem?.classList.add('sb-quick-add-source');
    }
    quickAddCard = trigger.closest('.product-item__media')
      || productItem?.querySelector('.product-item__media')
      || productItem;
    placeDesktopQuickAdd();
    setTimeout(unlockQuickViewScroll, 100);
  };

  document.addEventListener('click', setQuickAddAnchor, true);

  document.addEventListener('quickview:loaded', () => {
    placeDesktopQuickAdd();
    unlockQuickViewScroll();
    syncQuickViewAccessibility({ moveFocus: true });
  });
  document.addEventListener('pointerdown', event => {
    if (window.innerWidth < 720) return;
    const quickView = document.querySelector('[data-quick-view-modal].active');
    if (!quickView) return;
    if (event.target.closest('.quick-product--modal__inner') || event.target.closest('.sb-quick-add-trigger')) return;
    closeDesktopQuickAdd();
  });

  window.addEventListener('resize', () => {
    placeDesktopQuickAdd();
    syncQuickViewAccessibility();
  }, { passive: true });

  const quickView = document.querySelector('[data-quick-view-modal]');
  if (quickView) {
    let quickViewWasActive = false;
    quickView.addEventListener('keydown', event => {
      if (!quickView.classList.contains('active')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        quickView.querySelector('[data-modal-close]')?.click();
        return;
      }

      if (event.key !== 'Tab' || window.innerWidth >= 720) return;

      const focusable = quickViewFocusableElements(quickView);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    new MutationObserver(() => {
      if (quickView.classList.contains('active')) {
        const becameActive = !quickViewWasActive;
        quickViewWasActive = true;
        unlockQuickViewScroll();
        syncQuickViewAccessibility({ moveFocus: becameActive });
      } else if (quickViewWasActive) {
        quickViewWasActive = false;
        syncQuickViewAccessibility();
        quickView.removeAttribute('data-sb-qv-positioned');
        clearQuickAddSource();
        quickAddCard = null;
        restoreQuickViewScroll();
        requestAnimationFrame(() => {
          if (quickAddTrigger?.isConnected) quickAddTrigger.focus();
          quickAddTrigger = null;
        });
      }
    }).observe(quickView, { attributes: true, attributeFilter: ['class'] });
  }
})();
